"use client";

import { useState, useEffect, useRef } from "react";
import { CopilotKit, useCoAgent, useCoAgentStateRender } from "@copilotkit/react-core";
import { useLangGraphInterrupt } from "@copilotkit/react-core"; 
import { Code, Satellite } from "lucide-react";
import { AgentState } from "@/lib/types";


// type AgentState = {
//   proverbs: string[];
//   colleagues: Array<{ id: number; name: string; role: string }>;
//   language: "english" | "中文";
//   current_step: number;
//   observed_steps: string[];
//   plan: string[];
//   last_execute_codes: string[];
//   use_tools: string[];
//   tool_logs: string[];
//   output_files: string[];
//   input_files: string[];
//   agent_plan: string;
//   agent_debug: string;
// }

type Department = 'finance' | 'engineering' | 'admin'
interface AuthorizationInterruptEvent {
    type: 'auth',
    accessDepartment: Department,
}

export default function UserPlan() {
  const { state, setState } = useCoAgent<AgentState>({ name: "sample_agent" });
  
  // 本地状态管理
  const [editingIndex, setEditingIndex] = useState<number | null>(null);
  const [editingValue, setEditingValue] = useState<string>("");
  const [editingCodeIndex, setEditingCodeIndex] = useState<number | null>(null);
  const [editingCodeValue, setEditingCodeValue] = useState<string>("");
  const [responseValue, setResponseValue] = useState("");
  
  const helloworld = String(state.plan ? state.plan.join('\n') : '');
  // let helloworld ="hello world"
  // console.log("helowold : " , {helloworld})
  // console.log("json helowold : " , JSON.stringify({ helloworld }))


  //1 中断 ask 得到plan 
  // const [userEmail, setUserEmail] = useState('example@user.com');

  // 定义 getUserByEmail得到plan 
  function getUserPlan( state: AgentState): { plan: string , code?: string,number:number } {
      return { plan: String(state.plan ? state.plan.join('\n') : ''), code: String(state.last_execute_codes[state.current_step] || '') ,number : 1};
  }

  //2 中断 approve 得到code
  // const [userCode, setUserCode] = useState('example@user.com');
  // //1.2  定义 getUserCode得到code
  // function getUserCode(index: number, state: AgentState): { code: string } {
  //     return { code : String(state.last_execute_codes[index] || '') };
  // }

  // 新增：用ref保存最新state
  const stateRef = useRef(state);
  useEffect(() => {
    stateRef.current = state;
  }, [state]);

  useLangGraphInterrupt({
    enabled: ({ eventValue }) => eventValue?.type === 'plan' || eventValue?.type === 'debug',
    handler: ({ event, resolve }: any) => {
      new Promise((resolve) => setTimeout(resolve, 2000000));

      const { plan ,code,number} = getUserPlan( stateRef.current );

      console.log('state.plan in handler:', plan);
      console.log('state.code in handler:', code);
      return { plan ,code ,number};
    },
    render: ({ result, event, resolve }: any) => {
      if (event.value.type === 'plan') {
        return (
          <div>
            <pre>{result.plan}</pre>
            <div className="flex gap-4 mt-4">
              <button
                className="px-4 py-2 bg-red-100 text-red-700 rounded hover:bg-red-200 focus:outline-none focus:ring-2 focus:ring-red-400"
                onClick={() => resolve({ plan: result.plan, code: result.code })}
              >
                计划确认
              </button>
              <span className="inline-block w-4"></span>
              <button
                className="px-4 py-2 bg-gray-200 text-indigo-700 rounded hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-400"
                onClick={() => resolve(result.number)}
              >
                代码确认
              </button>
            </div>
          </div>
        );
      }
      if (event.value.type === 'debug') {
        return (
          <div>
            <pre>{result.code}</pre>
            <div className="flex gap-4 mt-4">
              <button
                className="px-4 py-2 bg-red-100 text-red-700 rounded hover:bg-red-200 focus:outline-none focus:ring-2 focus:ring-red-400"
                onClick={() => resolve({ plan: result.plan, code: result.code })}
              >
                代码确认
              </button>
              <span className="inline-block w-4"></span>
              <button
                className="px-4 py-2 bg-gray-200 text-indigo-700 rounded hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-400"
                onClick={() => resolve(result.number)}
              >
                再来一次
              </button>
            </div>
          </div>
        );
      }
      return <></>;
    }
  });
 

  const planLength = Array.isArray(state.plan) ? state.plan.length : 0;
  const progressPercentage = planLength > 0
    ? (state.current_step / planLength) * 100
    : 0;

  // 开始编辑步骤
  const startEditing = (index: number, step: string) => {
    setEditingIndex(index);
    setEditingValue(step || '');
    setIsInsertMode(false);
  };

  // 保存编辑
  const saveEdit = async () => {
    console.log('saveEdit called', { editingIndex, editingValue });
    if (editingIndex === null) return;
    if (!editingValue.trim()) {
      alert('内容不能为空');
      return;
    }
    // const newPlan = Array.isArray(state.plan) ? [...state.plan] : [];
    state.plan[editingIndex] = editingValue;
    setState({
      ...state,
      plan: state.plan
    });
    setEditingIndex(null);
    setEditingValue('');
    setIsInsertMode(false);
    console.log('after saveEdit', { editingIndex, editingValue });
  };

  // 取消编辑
  const [isInsertMode, setIsInsertMode] = useState(false);
  const cancelEdit = () => {
    if (isInsertMode && editingIndex !== null) {
      // 删除新插入的行
      const newPlan = Array.isArray(state.plan) ? [...state.plan] : [];
      newPlan.splice(editingIndex, 1);
      setState({
        ...state,
        plan: newPlan
      });
    }
    setEditingIndex(null);
    setEditingValue('');
    setIsInsertMode(false);
    console.log('after cancelEdit', { editingIndex, editingValue });
  };

  // 删除步骤
  const deleteStep = async (index: number) => {
    // const newPlan = [...state.plan];
    state.plan.splice(index, 1);
    setState({
      ...state,
      plan: state.plan,
      current_step: 0
    });
  };
  

  // 在组件内部添加useEffect用于渲染日志
  useEffect(() => {
    console.log('render', { editingIndex });
  }, [editingIndex]);

  // 日志追踪editingIndex变化
  useEffect(() => {
    console.log('editingIndex changed:', editingIndex);
  }, [editingIndex]);

  // 新增：将 state["agent_name"] 的内容按 \n 分割覆盖 state["plan"]
  // function overwritePlanFromAgentName() {
  //   if (typeof state.agent_name === 'string') {
  //     const newPlan = state.agent_name.split('\n').filter(line => line.trim() !== '');
  //     setState({ ...state, plan: newPlan });
  //   }
  // }

  // 插入步骤
  const insertStep = (index: number) => {
    // const newPlan = Array.isArray(state.plan) ? [...state.plan] : [];
    state.plan.splice(index + 1, 0, "新步骤");
    setState({
      ...state,
      plan: state.plan
    });
    setEditingIndex(index + 1);
    setEditingValue("新步骤");
    setIsInsertMode(true);
  };

  // 优化日志区渲染，始终返回 ReactNode
  const logStreamRender = useCoAgentStateRender<AgentState>({
    name: "sample_agent",
    render: ({ state }) => {
      if (!state.log_stream) return <></>;
      return (
        <section className="mb-6">
          <div className="mb-2 text-sm font-bold text-green-700">实时日志</div>
          <div className="p-3 bg-black text-green-300 rounded font-mono text-xs max-h-60 overflow-y-auto border border-gray-300">
            <pre className="whitespace-pre-wrap break-all">{state.log_stream}</pre>
          </div>
        </section>
      );
    },
  });

  return (
  <>  
  {Array.isArray(state.plan) && state.plan.length > 0 && (
    <div className="space-y-6 bg-neutral-900/80 border border-white/10 p-6 rounded-xl shadow-lg w-3/3 mx-0 ml-0">
      {/* 流式日志显示区 */}
      {/* {logStreamRender} */}
      <form className="space-y-4">
        {Array.isArray(state.plan) && state.plan.length > 0 && (
          <section>
            <div className="flex items-center justify-between mb-3">
              <h3 className="font-semibold text-lg text-white">执行进度</h3>
            </div>
            <div className="bg-white/10 h-2 rounded-full mb-4">
              <div 
                className="bg-emerald-500 h-2 rounded-full transition-all duration-500"
                style={{ width: `${progressPercentage}%` }}
              />
            </div>
            <ul className="space-y-4">
              {(Array.isArray(state.plan) ? state.plan : []).map((step, index) => (
                <li key={index} className="border border-white/10 rounded-lg overflow-hidden bg-neutral-800/60">
                  {/* 步骤头部 - 包含编辑按钮 */}
                  <div
                    className={`flex items-start space-x-3 p-3 ${
                      index === state.current_step 
                        ? 'bg-emerald-500/15 text-emerald-300'
                        : index < state.current_step
                        ? 'text-emerald-400 bg-emerald-500/5'
                        : 'bg-white/5 text-neutral-100'
                    }`}
                  >
                    {/* 状态图标 */}
                    <span className="flex-shrink-0 mt-1">
                      {index < state.current_step ? (
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                        </svg>
                      ) : index === state.current_step ? (
                        <svg className="w-5 h-5 animate-spin" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                        </svg>
                      ) : (
                        <div className="w-5 h-5 border-2 border-gray-300 rounded-full" />
                      )}
                    </span>
                    {/* 步骤内容 */}
                    <div className="flex-1">
                      {editingIndex === index ? (
                        <div className="space-y-2">
                          <textarea
                            value={editingValue}
                            onChange={(e) => setEditingValue(e.target.value)}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                            rows={2}
                          />
                          <div className="flex gap-2">
                            <button
                              type="button"
                              onClick={saveEdit}
                              className="px-3 py-1 bg-green-600 text-white text-sm rounded hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500"
                            >
                              保存
                            </button>
                            <button
                              type="button"
                              onClick={cancelEdit}
                              className="px-3 py-1 bg-gray-600 text-white text-sm rounded hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500"
                            >
                              取消
                            </button>

                          </div>
                        </div>
                      ) : (
                        <div className="flex items-start justify-between">
                          <span className={index === state.current_step ? 'font-medium' : ''}>
                            {step}
                          </span>
                          <div className="flex gap-1 ml-2">
                            <button
                              type="button"
                              onClick={() => startEditing(index, step)}
                              className="p-1 text-gray-500 hover:text-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 rounded"
                            >
                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                              </svg>
                            </button>
                            <button
                              type="button"
                              onClick={() => insertStep(index)}
                              className="p-1 text-gray-500 hover:text-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 rounded"
                            >
                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
                              </svg>
                            </button>
                            <button
                              type="button"
                              onClick={() => deleteStep(index)}
                              className="p-1 text-gray-500 hover:text-red-600 focus:outline-none focus:ring-2 focus:ring-red-500 rounded"
                            >
                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                              </svg>
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* 工具调用（如果有） */}
                  {state.use_tools && state.use_tools[index] && (
                    <div className="px-4 py-2 border-t border-white/10 bg-white/5">
                      <div className="flex items-center text-sm text-neutral-300">
                        <span>工具:</span>
                        <code className="ml-2 px-2 py-0.5 bg-white/10 rounded text-neutral-200">
                          {state.use_tools[index]}
                        </code>
                      </div>
                    </div>
                  )}
                 {/* 输入文件（如果有） */}
                  {state.input_files && state.input_files[index] && (
                    <div className="px-4 py-2 border-t border-white/10 bg-white/5">
                      <div className="flex items-start text-sm text-neutral-300">
                        <span>输入:</span>
                        <code className="ml-2 px-2 py-0.5 bg-white/10 rounded text-neutral-200 whitespace-pre-line block">
                          {Array.isArray(state.input_files[index])
                            ? state.input_files[index].map((f: string) => f.split('/').pop()).join('\n')
                            : (typeof state.input_files[index] === 'string' ? state.input_files[index].split('/').pop() : state.input_files[index])}
                        </code>
                      </div>
                    </div>
                  )}

                 {/* 输出文件（如果有） */}
                 {state.output_files && state.output_files[index] && (
                    <div className="px-4 py-2 border-t border-white/10 bg-white/5">
                      <div className="flex items-start text-sm text-neutral-300">
                        <span>输出:</span>
                        <code className="ml-2 px-2 py-0.5 bg-white/10 rounded text-neutral-200 whitespace-pre-line block">
                          {Array.isArray(state.output_files[index])
                            ? state.output_files[index].map((f: string) => f.split('/').pop()).join('\n')
                            : (typeof state.output_files[index] === 'string' ? state.output_files[index].split('/').pop() : state.output_files[index])}
                        </code>
                      </div>
                    </div>
                  )}
                  
                  {/* 执行代码（如果有） */}
                  {state.last_execute_codes && state.last_execute_codes[index] && (
                    <div className="p-4 border-t border-white/10 bg-neutral-900/50">
                      <div className="flex items-center justify-between mb-2">
                        <span className="text-sm text-neutral-300">代码生成</span>
                        <div className="flex items-center gap-2">
                          <span className="text-xs px-2 py-1 rounded-full bg-emerald-500/15 text-emerald-300">
                            已完成
                          </span>
                          <button
                            type="button"
                            onClick={() => {
                              setEditingCodeIndex(index);
                              setEditingCodeValue(state.last_execute_codes[index]);
                            }}
                            className="p-1 text-neutral-400 hover:text-emerald-300 focus:outline-none focus:ring-2 focus:ring-emerald-500 rounded"
                          >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                            </svg>
                          </button>
                        </div>
                      </div>
                      {editingCodeIndex === index ? (
                        <div className="space-y-2">
                          <textarea
                            value={editingCodeValue}
                            onChange={(e) => setEditingCodeValue(e.target.value)}
                            className="w-full text-sm font-mono bg-black/40 p-3 rounded border border-white/10 text-neutral-100 focus:outline-none focus:ring-2 focus:ring-emerald-500 whitespace-pre-wrap break-all leading-relaxed"
                            style={{ fontFamily: 'monospace', fontSize: '0.875rem', lineHeight: '1.5' }}
                            rows={12}
                          />
                          <div className="flex gap-2">
                            <button
                              type="button"
                              onClick={() => {
                                const newCodes = [...state.last_execute_codes];
                                newCodes[index] = editingCodeValue;
                                setState({
                                  ...state,
                                  last_execute_codes: newCodes
                                });
                                setEditingCodeIndex(null);
                              }}
                              className="px-3 py-1 bg-emerald-600 text-white text-sm rounded hover:bg-emerald-500 focus:outline-none focus:ring-2 focus:ring-emerald-500"
                            >
                              保存
                            </button>
                            <button
                              type="button"
                              onClick={() => setEditingCodeIndex(null)}
                              className="px-3 py-1 bg-neutral-700 text-white text-sm rounded hover:bg-neutral-600 focus:outline-none focus:ring-2 focus:ring-neutral-500"
                            >
                              取消
                            </button>
                          </div>
                        </div>
                      ) : (
                      <pre className="text-sm font-mono bg-black/40 p-3 rounded text-neutral-100 whitespace-pre-wrap break-all leading-relaxed" style={{ fontFamily: 'monospace', fontSize: '0.875rem', lineHeight: '1.5' }}>
                        <code>{state.last_execute_codes[index]}</code>
                      </pre>
                      )}
                    </div>
                  )}

                  {/* 执行log（如果有） */}
                  {state.tool_logs && state.tool_logs[index] && (
                    <div className="p-4 border-t border-white/10 bg-neutral-900/50">
                      <div className="flex items-center justify-between mb-2">
                        <span className="text-sm text-neutral-300">执行代码</span>
                        <span className="text-xs px-2 py-1 rounded-full bg-emerald-500/15 text-emerald-300">
                          logs   
                        </span>
                      </div>
                      <pre className="text-sm font-mono bg-black/40 p-3 rounded text-neutral-100 overflow-x-auto">
                        <code>{state.tool_logs[index]}</code>
                      </pre>
                    </div>
                  )}
                </li>
              ))}
            </ul>
          </section>
        )}
      </form>
    </div>
   )} 
  </>
  );
}
